<template>
  <div class="home">
    <panel-head title="首页面板" subtitle="HOME PANEL" :export-url="exportUrl"></panel-head>
    <div class="panel-content">
      <h3 class="panel-content__title">数据概览</h3>
      <div class="panel-content__consume" v-if="platform !== 'admin'">
        <div class="panel-content__consume-item" v-if="balance.today">
          <span>今日消耗：</span>
          <span>总消耗{{balance.today.cost}}元（现金消耗{{balance.today.cash}}元，返货消耗{{balance.today.rebate}}元）</span>
        </div>
        <div class="panel-content__consume-item" v-if="balance.yesterday">
          <span>昨日消耗：</span>
          <span>总消耗{{balance.yesterday.cost}}元（现金消耗{{balance.yesterday.cash}}元，返货消耗{{balance.yesterday.rebate}}元）</span>
        </div>
      </div>
      <div class="panel-content__select-list">
        <ny-date-range class="panel-content__select-item" shortcut v-model="date"
                       @change="handleDateChange"></ny-date-range>
        <template v-if="platform === 'agency' || platform === 'admin'">
          <span class="panel-content__label">账户类型</span>
          <ny-select class="panel-content__select-item" :data="accountTypes" filterable v-model="accountType"
                     has-search-icon></ny-select>
          <ny-select class="panel-content__select-item" :data="accountNames" filterable v-model="accountName"
                     has-search-icon></ny-select>
          <!-- <el-input class="panel-content__select-item" v-model="accountName" placeholder="请输入账户名称"></el-input> -->
          <div class="panel-content__select-item">
            <up-button @click="handleSearch">查询</up-button>
          </div>
        </template>
      </div>
      <div class="panel-content__table-wrap">
        <ny-table class="panel-content__table" :page="page" @current-change="() => getReportData('currentChange')"
                  @size-change="() => getReportData('sizeChange')">
          <template slot="operate" v-if="page.data.length">
            <up-table-column label="操作" width="88" fixed="right">
              <template slot-scope="scope">
                <up-button @click="handleClick(scope.row)" type="text" size="small">查看明细</up-button>
              </template>
            </up-table-column>
          </template>
        </ny-table>
        <ny-table v-show="showDatePage" class="panel-content__table" :page="datePage"
                  @current-change="getDateDetailData" @size-change="getDateDetailData">
        </ny-table>
      </div>
      <div class="panel-content__chart" v-if="platform !== 'admin'">
        <ve-line :data="chartData" :settings="chartSettings"></ve-line>
        <div v-if="!chartData.rows.length" class="panel-content__none">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { PanelHead, NyDateRange, NyTable, NySelect } from '@/global/components';
  import { getDiffDate } from '@/global/util/date';
  import { BASE_URL } from '@/global/util/constants'
  import qs from 'qs'

  export default {
    name: 'HomePanel',
    components: {
      PanelHead, NyDateRange, NyTable, NySelect
    },
    data () {
      this.chartSettings = {};

      return {
        platform: '',
        date: getDiffDate(-7, { result: [] }),
        chartData: {
          columns: ['日期', '曝光', '点击'],
          rows: []
        },
        pageData: {},
        showDatePage: false,
        request: null,
        accountName: 'all',
        accountNames: [],
        accountType: 'all',
        accountTypes: []
      }
    },
    computed: {
      ...mapGetters({
        userid: 'login/userid',
        balance: 'login/balance',
        page: 'home/page',
        datePage: 'home/datePage'
      }),
      exportUrl () {
        const path = this.platform === 'agency' || this.platform === 'admin' ? 'first' : 'firstDetail'
        return this.platform === 'ad-user' && !this.pageData.ader_id ?
          '' :
          `${BASE_URL}/${this.platform}/data/${path}?${qs.stringify(this.getRequestParams({
            platform: this.platform,
            isExport: true
          }))}`;
      }
    },
    created () {
      this.platform = this.$router.currentRoute.meta.platform
      if (this.platform === 'agency' || this.platform === 'admin') {
        this.getAccountNameList()
        this.getAccountTypeList()
      }
      this.getReportData()
      if (this.platform !== 'admin') {
        this.getChartData()
      }
    },
    methods: {
      ...mapActions([
        'home/getReportData',
        'home/getDateDetailData',
        'home/getChartData',
        'home/getAccountNameList',
        'home/getAccountTypeList'
      ]),
      getRequestParams ({ type, platform, isExport = false } = {}) {
        const [startDate, endDate] = this.date;
        const params = { start_time: startDate, end_time: endDate }
        const isAgencyOrAdmin = ['agency', 'admin'].includes(platform)

        if (type === 'datePage' && isAgencyOrAdmin) {
          params.ader_id = this.pageData.account_id
        } else {
          if (isAgencyOrAdmin) {
            params.account_id = this.accountName
            params.account_type = this.accountType
          }
          params.user_id = this.userid
        }

        if (isAgencyOrAdmin) {
          params.account_id = this.accountName
          params.account_type = this.accountType
        }

        if (type === 'datePage' || type === 'page') {
          params.page = this[type].currentPage
          params.size = this[type].pageSize
        }

        if (isExport) {
          params.is_export = 1
        }
        return params;
      },
      getReportData (changeType) {
        const params = this.getRequestParams({ type: 'page', platform: this.platform })
        if (changeType === 'sizeChange') {
          params.page = 1
        }
        this['home/getReportData']({ request: this.request, platform: this.platform, params, changeType })
      },
      getDateDetailData () {
        const platform = this.platform
        const params = this.getRequestParams({ type: 'datePage', platform })
        this['home/getDateDetailData']({ request: this.request, platform, params })
      },
      async getChartData () {
        const params = this.getRequestParams()
        if (this.platform === 'agency') {
          params.account_id = this.accountName
        }
        const { header, data } = await this['home/getChartData']({
          request: this.request,
          platform: this.platform,
          params
        })
        const rows = []
        for (let item of data) {
          var row = {}
          for (var key in header) {
            row[header[key]] = item[key]
          }
          rows.push(row)
        }

        this.chartData.rows = rows
      },
      async getAccountNameList () {
        this['home/getAccountNameList']({ request: this.request, platform: this.platform })
          .then(res => {
            this.accountNames = res.data
          })
      },
      async getAccountTypeList () {
        this['home/getAccountTypeList']({ request: this.request, platform: this.platform })
          .then(res => {
            this.accountTypes = res.data
          })
      },
      handleClick (row) {
        if (row.ader_id === this.pageData.ader_id && this.showDatePage) {
          this.showDatePage = false
        } else {
          this.showDatePage = true
          this.pageData = row
          this.getDateDetailData()
        }
      },
      handleDateChange () {
        this.showDatePage = false
        this.getReportData()
        if (this.platform !== 'admin') {
          this.getChartData()
        }
      },
      handleSearch () {
        this.showDatePage = false
        this.getReportData()
        if (this.platform !== 'admin') {
          this.getChartData()
        }
      }
    }
  }
</script>
<style lang="scss">
  @include b(panel-content) {
    @include e(consume) {
      padding: 14px 20px 0;
    }

    @include e(consume-item) {
      line-height: 20px;
      span {
        font-size: 16px;
      }
    }
  }
</style>
